import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Input,
  FormControl,
  CircularProgress,
  IconButton,
} from "@mui/joy";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/controllers/useAuth";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await login(username, password);
      navigate("/");
    } catch (err) {
      setError("Nom d'utilisateur ou mot de passe incorrect");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "background.body",
      }}
    >
      <Box
        sx={{
          width: "clamp(280px, 90vw, 420px)",
          padding: 4,
          backgroundColor: "background.surface",
          borderRadius: "md",
          boxShadow: "md",
        }}
      >
        <Typography level="h4" fontWeight="bold" textAlign="center" sx={{ mb: 2 }}>
          Connexion
        </Typography>

        {error && (
          <Typography level="h4" color="danger" textAlign="center" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}

        <form onSubmit={handleLogin}>
          <FormControl sx={{ mb: 2 }}>
            <Typography fontWeight="bold">Nom d'utilisateur</Typography>
            <Input
              type="text"
              placeholder="Entrez votre nom d'utilisateur"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </FormControl>

          <FormControl sx={{ mb: 2 }}>
            <Typography fontWeight="bold">Mot de passe</Typography>
            <Input
              type={showPassword ? "text" : "password"}
              placeholder="Entrez votre mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              endDecorator={
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  sx={{ color: "neutral.500" }}
                >
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
              }
            />
          </FormControl>

          <Button type="submit" fullWidth sx={{ mt: 2 }} color="primary" disabled={loading}>
            {loading ? <CircularProgress size="sm" /> : "Se connecter"}
          </Button>
        </form>
      </Box>
    </Box>
  );
};

export default LoginPage;
